// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__iVSaV","container":"styles_container__hs9iR","slide":"styles_slide__jrWqC"};